import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as periodosService from '../../services/periodos/periodosService';
import {
  buildPeriodoCursadaValidationError,
  classifyPeriodosError,
  PERIODO_CURSADA_OPTIONS,
  toCreatePeriodoCursadaPayload,
  validateInscriptionDates,
  validateInscriptionInsidePeriod,
  validatePeriodDates,
  validatePeriodoCursadaFormAdd,
} from '../../services/periodos/periodosDto';
import { findSelectOptionByValue } from '../../services/selectOptions';
import { LookupAnioAcademicos } from '../AnioAcademico/LookupAnioAcademicos';
import { todayCalendarDate } from '../../services/dates/dateService';
import { CalendarDatePicker } from '../common/CalendarDatePicker';
import Select from '../common/AppSelect';

export class AddPeriodoCursada extends Component {
  static displayName = AddPeriodoCursada.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showErrorMessage: false,
      success: false,
      errorMessage: '',
      showLookupAnios: false,
      anio: { codigo: '', descripcion: '' },
      startDate: todayCalendarDate(),
      endDate: todayCalendarDate(),
      startInscriptionDate: todayCalendarDate(),
      endInscriptionDate: todayCalendarDate(),
      periodoValue: '',
      periodoOption: null,
    };
  }

  async componentDidMount() {
    await constantClass.canAccess('WWPeriodoCursada');
  }

  handleConfirmButton = () => {
    const datesOk = validatePeriodDates(this.state.startDate, this.state.endDate);
    const inscriptionDatesOk = validateInscriptionDates(
      this.state.startInscriptionDate,
      this.state.endInscriptionDate
    );
    const isOkToSave = validatePeriodoCursadaFormAdd({
      descripcion: this.state.periodoValue,
      anioDescripcion: this.state.anio.descripcion,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      startInscriptionDate: this.state.startInscriptionDate,
      endInscriptionDate: this.state.endInscriptionDate,
    });
    const inscriptionDateInsidePeriodDates = validateInscriptionInsidePeriod({
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      startInscriptionDate: this.state.startInscriptionDate,
      endInscriptionDate: this.state.endInscriptionDate,
    });
    const errorMessage = buildPeriodoCursadaValidationError({
      formValid: isOkToSave,
      datesOk,
      inscriptionDatesOk,
      inscriptionInsidePeriod: inscriptionDateInsidePeriodDates,
    });

    if (isOkToSave && datesOk && inscriptionDatesOk && inscriptionDateInsidePeriodDates) {
      this.saveStudent();
      return;
    }

    this.setState({ showErrorMessage: true, errorMessage });
  };

  handlePeriodoChange = (option) => {
    const periodoValue = option?.value ?? '';
    this.setState({
      periodoValue,
      periodoOption: option,
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  handleShowAniosLookup = () => {
    this.setState({ showLookupAnios: true });
  };

  handleStartDate = (date) => {
    this.setState({ startDate: date, showErrorMessage: false, errorMessage: '' });
  };

  handleEndDate = (date) => {
    this.setState({ endDate: date, showErrorMessage: false, errorMessage: '' });
  };

  handleEndInscripcionDate = (date) => {
    this.setState({ endInscriptionDate: date, showErrorMessage: false, errorMessage: '' });
  };

  handleStartInscriptionDate = (date) => {
    this.setState({ startInscriptionDate: date, showErrorMessage: false, errorMessage: '' });
  };

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  };

  handleSelectAnioItem = (e) => {
    const anioProperties = e.split('%');
    this.setState({
      showLookupAnios: false,
      showErrorMessage: false,
      errorMessage: '',
      anio: {
        codigo: anioProperties[0],
        descripcion: anioProperties[1],
      },
    });
  };

  render() {
    if (this.state.success) {
      return <Redirect to="/md-pcr" />;
    }

    const { loading } = this.state;

    return (
      <div className="md-page md-add-pcr">
        <Link className="md-page__back-link" to="/md-pcr">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Nuevo Período de Cursada</h1>
        </div>
        <p className="md-page__subtitle">
          Seleccione período y año académico, luego defina las fechas del período y de inscripción.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están guardando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Período de cursada</span>
            <Select
              className="md-page__field-select"
              value={this.state.periodoOption}
              options={PERIODO_CURSADA_OPTIONS}
              placeholder="Seleccioná el período"
              onChange={this.handlePeriodoChange}
              disabled={loading}
            />
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Año académico</span>
            <div className="md-page__picker-block">
              {!loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowAniosLookup}>
                  Seleccionar año académico
                </button>
              ) : null}
              <div className="md-page__field-readonly">{this.state.anio.descripcion || '\u00a0'}</div>
            </div>
          </div>

          <section className="md-page__form-section">
            <p className="md-page__form-section-title">Fechas del período</p>
            <div className="md-page__form-date-row">
              <div className="md-page__field">
                <label className="md-page__field-label" htmlFor="pcr-fecha-inicio">
                  Fecha de inicio
                </label>
                <CalendarDatePicker
                  inputId="pcr-fecha-inicio"
                  className="md-page__field-input"
                  selected={this.state.startDate}
                  onChange={this.handleStartDate}
                  disabled={loading}
                />
              </div>
              <div className="md-page__field">
                <label className="md-page__field-label" htmlFor="pcr-fecha-fin">
                  Fecha de fin
                </label>
                <CalendarDatePicker
                  inputId="pcr-fecha-fin"
                  className="md-page__field-input"
                  selected={this.state.endDate}
                  onChange={this.handleEndDate}
                  disabled={loading}
                />
              </div>
            </div>
          </section>

          <section className="md-page__form-section">
            <p className="md-page__form-section-title">Fechas de inscripción</p>
            <div className="md-page__form-date-row">
              <div className="md-page__field">
                <label className="md-page__field-label" htmlFor="pcr-inicio-inscripcion">
                  Inicio de inscripción
                </label>
                <CalendarDatePicker
                  inputId="pcr-inicio-inscripcion"
                  className="md-page__field-input"
                  selected={this.state.startInscriptionDate}
                  onChange={this.handleStartInscriptionDate}
                  disabled={loading}
                />
              </div>
              <div className="md-page__field">
                <label className="md-page__field-label" htmlFor="pcr-fin-inscripcion">
                  Fin de inscripción
                </label>
                <CalendarDatePicker
                  inputId="pcr-fin-inscripcion"
                  className="md-page__field-input"
                  selected={this.state.endInscriptionDate}
                  onChange={this.handleEndInscripcionDate}
                  disabled={loading}
                />
              </div>
            </div>
          </section>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              Guardar cambios
            </button>
          </div>
        </div>

        {this.state.showLookupAnios ? (
          <LookupAnioAcademicos selectItem={this.handleSelectAnioItem} hideLookup={this.handleHideLookup} />
        ) : null}
      </div>
    );
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await periodosService.savePeriodoCursada(
        toCreatePeriodoCursadaPayload({
          descripcion: this.state.periodoValue,
          fechaInicio: this.state.startDate,
          fechaFin: this.state.endDate,
          inicioInscripcion: this.state.startInscriptionDate,
          finInscripcion: this.state.endInscriptionDate,
          anioAcademicoCod: this.state.anio.codigo,
        })
      );
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyPeriodosError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loading: false,
        success: false,
        showErrorMessage: true,
        errorMessage: outcome.message,
      });
    }
  }
}
